import { appConstants } from "../../constants/appconstants";
import { postApiCall } from "../../utils/ApiMethods";

const FetchSCMKpiAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/scm/kpi-page-data`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_SCM_DETAIL_VIEW_ACTION' }, data);
        dispatch(resData);
    }
}

const FetchSCMMainAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/scm/main-page-data`, requestObj)
        
        // const data = {
        //     "title": "Should Cost Modelling",
        //     "currentYearValue": "21518",
        //     "lastYearValue": "$-41553.5BN",
        //     "percentage": null,
        //     "lastUpdate": "May 2025",
        //     "refreshFrequency": "30 Days",
        //     "apps": [
        //         {
        //             "app": "SCM Platform",
        //             "url": "https://scm.preprod.mypepsico.com/",
        //             "isActive": true,
        //             "chartDisplay": true
        //         }
        //     ],
        //     "description": "Corrugate | Can | Preform and Bottle"
        // }
        var resData = Object.assign({ type: 'SUCCESS_SCM_CARD_ACTION' }, data);
        dispatch(resData);
    }
}

export { FetchSCMKpiAction, FetchSCMMainAction }